import { render, staticRenderFns } from "./template.vue?vue&type=template&id=200984d8&"
import script from "./template.vue?vue&type=script&lang=js&"
export * from "./template.vue?vue&type=script&lang=js&"
import style0 from "./template.vue?vue&type=style&index=0&id=200984d8&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\public\\Isaura\\id.es6.vn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200984d8')) {
      api.createRecord('200984d8', component.options)
    } else {
      api.reload('200984d8', component.options)
    }
    module.hot.accept("./template.vue?vue&type=template&id=200984d8&", function () {
      api.rerender('200984d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/template.vue
// module id = 551
// module chunks = 16